import React from 'react';

export function LabelPhoneMask({ phone }) {

  const insertElement = ({ phone, index, quantityRemove, character }) => {
    return phone.splice(index, quantityRemove, character);
  }

  const maskPhone = (phone) => {
    
    const phoneCharacters = phone.split("")

    insertElement({
      phone: phoneCharacters,
      index: 0,
      quantityRemove: 0,
      character: "("
    })

    insertElement({
      phone: phoneCharacters,
      index: 3,
      quantityRemove: 0,
      character: ")"
    })

    return phoneCharacters.join("");
  }

  return (
    <b>
      {maskPhone(phone)}
    </b>
  );
}
